import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { NOTIFICATION_TABS } from 'constants/general';

import type INotificationsHeader from './interfaces/INotificationsHeader';

import styles from './sass/NotificationsModal.module.scss';

function NotificationsHeader({
  activeTab,
  onTabClick,
  onMarkAllAsRead,
}: INotificationsHeader) {
  const { t } = useTranslation();

  return (
    <div className={styles.header}>
      <div className={styles.tabs}>
        <div
          className={clsx(styles.tab, {
            [styles.active]: activeTab === NOTIFICATION_TABS.ALL,
          })}
          onClick={() => onTabClick(NOTIFICATION_TABS.ALL)}
          onKeyDown={() => onTabClick(NOTIFICATION_TABS.ALL)}
          role="button"
          tabIndex={0}
          aria-label={t('common.allNotifications')}
        >
          {t('common.allNotifications')}
        </div>
        <div
          className={clsx(styles.tab, {
            [styles.active]: activeTab === NOTIFICATION_TABS.UNREAD,
          })}
          onClick={() => onTabClick(NOTIFICATION_TABS.UNREAD)}
          onKeyDown={() => onTabClick(NOTIFICATION_TABS.UNREAD)}
          role="button"
          tabIndex={0}
          aria-label={t('common.unreadNotifications')}
        >
          {t('common.unreadNotifications')}
        </div>
      </div>
      <div className={styles.markAllButtonWrapper}>
        <div
          className={styles.markAllButton}
          onClick={onMarkAllAsRead}
          onKeyDown={(e) => e.key === 'Enter' && onMarkAllAsRead?.()}
          role="button"
          tabIndex={0}
          aria-label={t('common.markAllAsRead')}
        >
          {t('common.markAllAsRead')}
        </div>
      </div>
    </div>
  );
}

export default NotificationsHeader;
